import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface CommentButtonProps {
  commentCount: number;
  onClick: () => void;
  className?: string;
}

export function CommentButton({ commentCount, onClick, className }: CommentButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="ghost"
      className={`relative h-11 px-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-white/20 rounded-xl transition-all gap-1 ${className || ''}`}
    >
      <MessageSquare className="w-4 h-4" />
      <span className="text-base font-medium">Comments</span>
      {commentCount > 0 && (
        <Badge 
          variant="secondary" 
          className="ml-1 bg-white/20 text-white h-5 min-w-[20px] px-1.5 text-xs font-bold rounded-full"
        >
          {commentCount >= 1000 ? '1K+' : commentCount}
        </Badge>
      )}
    </Button>
  );
}
